import { useState } from 'react';
import Commandes from './Commandes';
import CommercantCommandes from './CommercantCommandes';
import { resolveMerchantOperationalScope } from '../utils/assistanceSession';

function readAdminUser() {
  try {
    const userData = localStorage.getItem('admin_user');
    if (userData) return JSON.parse(userData);
  } catch (error) {
    console.error('Erreur parsing user data:', error);
  }
  return null;
}

/**
 * Wrapper qui affiche la page appropriée selon le contexte opérationnel
 * - COMMERCANT ou SUPER_ADMIN en assistance : CommercantCommandes (boutique courante)
 * - SUPER_ADMIN/ADMIN hors assistance : Commandes (vue plateforme)
 */
const CommandesWrapper = () => {
  const [currentUser] = useState(() => readAdminUser());
  const scope = resolveMerchantOperationalScope(currentUser);

  if (scope.scopedToMerchant && scope.commercantId) {
    return <CommercantCommandes commercantId={scope.commercantId} />;
  }

  return <Commandes />;
};

export default CommandesWrapper;
